import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalDataService } from '@core/services';
import { CampagneDetailsService, isCampaignDetailsReady } from '@core/services';
import { CampagneService } from '@core/services/campagne.service';
import { NavigateUtil } from '@shared/utils/navigate.util';
import { EMPTY, Subject, catchError, distinctUntilChanged, forkJoin, from, map, switchMap, takeUntil } from 'rxjs';
@Component({
  selector: 'app-suivi-campagne-une-seule-fois',
  templateUrl: './suivi-campagne-une-seule-fois.component.html',
  styleUrls: ['./suivi-campagne-une-seule-fois.component.scss']
})
export class SuiviCampagneUneSeuleFoisComponent implements OnInit, AfterViewInit, OnDestroy {

  isHydrating = false;
  loadError = false;
  private destroy$ = new Subject<void>();

  constructor(
    private el: ElementRef,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private _CampagneService: CampagneService,
    private _CampagneDetailsService: CampagneDetailsService,
    public _GlobalDataService: GlobalDataService,
  ) { }

  ngOnInit(): void {
    this.activeRoute.paramMap
      .pipe(
        map(params => params.get('IdCampagne')),
        distinctUntilChanged(),
        switchMap(idCampagne => {
          if (!idCampagne || this.isCampaignReadyFor(idCampagne)) {
            this.isHydrating = false;
            return EMPTY;
          }

          this.isHydrating = true;
          this.loadError = false;
          return forkJoin({
            campagneRes: this._CampagneService.get(idCampagne),
            _statut: from(this._GlobalDataService.getStatutMapping()),
          }).pipe(
            catchError(error => {
              console.error(`Unable to hydrate campaign ${idCampagne}`, error);
              this.isHydrating = false;
              this.loadError = true;
              return EMPTY;
            })
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(({ campagneRes: res }) => {
        if (res?.campagne) {
          this._GlobalDataService.Campagne = res.campagne;
        }
        this.isHydrating = false;
        this._CampagneDetailsService.gotoDetailCampagne();
      });
  }

  get isCampaignReady(): boolean {
    const idCampagne = this.activeRoute.snapshot.paramMap.get('IdCampagne');
    return !!idCampagne && this.isCampaignReadyFor(idCampagne);
  }

  private isCampaignReadyFor(idCampagne: string): boolean {
    return isCampaignDetailsReady(
      this._GlobalDataService.isLoaded,
      this._GlobalDataService.CampagneExt?.IdCampagne,
      idCampagne
    );
  }
  ngAfterViewInit(): void {
    NavigateUtil.goToTopSideNavContent(this.el);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  gotoSuiviCampagne() {
    let path = "/campagne/home";

    if (this._GlobalDataService.isStandaloneContext()) {
      path = "/standalone/home"
    }

    this.router.navigate([path, { outlets: { 'navview': ['suivi-campagnes', this._GlobalDataService.Annonceur.IdAnnonceur] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: true
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
        // this.showSpinner = false;

      } else {
        console.log("Navigation has failed!");
        // this.showSpinner = false;
      }
    });
  }
}
